import type AuthStore from './stores/auth-store';
import type ProviderStore from './stores/provider-store';
import type SearchStore from './stores/search-store';

class Cache {
  authStore!: AuthStore;
  searchStore!: SearchStore;
  providerStore!: ProviderStore;
}

const cache = new Cache();

export default cache;
